<div class="onboarding-wrapper">
  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Validando enlace...</p>
  </div>

  <!-- Error -->
  <div *ngIf="!loading && errorMessage" class="error-container">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <h2>No se puede continuar</h2>
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Onboarding Flow -->
  <div *ngIf="!loading && sessionValid && !errorMessage">
    <!-- Header -->
    <div class="onboarding-header">
      <h1 class="onboarding-title">Registro Credilow</h1>
    </div>

    <!-- Step: Welcome -->
    <app-welcome
      *ngIf="currentStep === OnboardingStep.Welcome"
      (accepted)="onWelcomeAccepted()">
    </app-welcome>

    <!-- Step: DNI Front -->
    <app-dni-front
      *ngIf="currentStep === OnboardingStep.DniFront"
      (captured)="onDniFrontCaptured($event)">
    </app-dni-front>

    <!-- Step: DNI Back -->
    <app-dni-back
      *ngIf="currentStep === OnboardingStep.DniBack"
      [frontFile]="dniFrontFile"
      (validated)="onDniValidated($event)"
      (validationFailed)="onDniValidationFailed()">
    </app-dni-back>

    <!-- Step: DNI Confirmation -->
    <app-dni-confirmation
      *ngIf="currentStep === OnboardingStep.DniConfirmation"
      [identityData]="identityData"
      (confirmed)="onDniConfirmed()">
    </app-dni-confirmation>

    <!-- Step: Liveness -->
    <app-liveness
      *ngIf="currentStep === OnboardingStep.Liveness"
      (completed)="onLivenessCompleted()">
    </app-liveness>

    <!-- Step: Phone -->
    <app-phone
      *ngIf="currentStep === OnboardingStep.Phone"
      [prefillPhone]="prefillPhone"
      (submitted)="onPhoneSubmitted($event)">
    </app-phone>

    <!-- Step: Phone Verification -->
    <app-phone-verification
      *ngIf="currentStep === OnboardingStep.PhoneVerification"
      [verificationId]="smsVerificationId"
      (verified)="onPhoneVerified()">
    </app-phone-verification>

    <!-- Step: Email -->
    <app-email
      *ngIf="currentStep === OnboardingStep.Email"
      [prefillEmail]="prefillEmail_"
      (submitted)="onEmailSubmitted($event)">
    </app-email>

    <!-- Step: Email Verification -->
    <app-email-verification
      *ngIf="currentStep === OnboardingStep.EmailVerification"
      [verificationId]="emailVerificationId"
      (verified)="onEmailVerified($event)">
    </app-email-verification>

    <!-- Step: Location -->
    <app-location
      *ngIf="currentStep === OnboardingStep.Location"
      [validationToken]="validationToken"
      (saved)="onLocationSaved()">
    </app-location>

    <!-- Step: Services -->
    <app-services
      *ngIf="currentStep === OnboardingStep.Services"
      [validationToken]="validationToken"
      (saved)="onServicesSaved()">
    </app-services>

    <!-- Step: References -->
    <app-references
      *ngIf="currentStep === OnboardingStep.References"
      [validationToken]="validationToken"
      [isPasswordRequired]="isPasswordRequired"
      (saved)="onReferencesSaved($event)">
    </app-references>

    <!-- Step: Password -->
    <app-password
      *ngIf="currentStep === OnboardingStep.Password"
      [validationToken]="validationToken"
      [references]="savedReferences"
      (saved)="onPasswordSaved()">
    </app-password>

    <!-- Step: Result -->
    <app-result
      *ngIf="currentStep === OnboardingStep.Result"
      [success]="success">
    </app-result>
  </div>
</div>
